import axiosHelper from '../utils/axios';

export default (() => {
  const networkAssetPath = "networkAsset/airfinder";
  const networkAssetPathV2 = "networkAsset/airfinder/v2";
  const networkAssetPathV3 = "networkAsset/airfinder/v3";
  const statusPath = `${networkAssetPathV2}/status`;
  const statusPathV3 = `${networkAssetPathV3}/status`;
  const sitePath = 'networkAsset/airfinder/site/';

  async function getNetworkConnectionStatus(siteId) {
    const response = await axiosHelper
      .getNetworkAsset()
      .get(`${statusPath}?siteId=${siteId}`);
    return response.data;
  }

  async function getDeviceStatus(siteId) {
    const url = statusPathV3.concat("?siteId=", siteId);

    const r = await axiosHelper
      .getNetworkAsset()
      .get(url);

    const totalRecordsHeader = r.headers["total_records"];
    const totalRows = totalRecordsHeader ? Number(totalRecordsHeader) : 0;
    const data = r.data;

    return { rows: data, total: totalRows };
  }

  async function getDevicesCount(siteId) {
    const url = networkAssetPathV2.concat("/count?siteId=", siteId);

    const response = await axiosHelper
      .getNetworkAsset()
      .get(url);

    return response.data;
  }

  async function getUnprovisionedLocationBeaconStatus(
    siteId,
    page,
    size,
    orderBy,
    sortBy
  ) {
    const url = networkAssetPathV3.concat(
      "/locations/unprovisioned?siteId=",
      siteId,
      "&page=",
      page.toString(),
      "&size=",
      size ? size.toString() : "",
      "&orderBy=",
      orderBy,
      "&sort=lbLastSeenTime%3Aasc"      
    );

    const r = await axiosHelper
      .getNetworkAsset()
      .get(url);

    const totalRecordsHeader = r.headers["total_records"];
    const totalRows = totalRecordsHeader ? Number(totalRecordsHeader) : 0;
    const data = r.data;

    return { rows: data, total: totalRows };
  }

  async function getUnprovisionedAccessPointStatus(
    siteId,
    page,
    size,
    orderBy,
    sortBy
  ) {
    const url = networkAssetPathV3.concat(
      "/accessPoints/unprovisioned?siteId=",
      siteId,
      "&page=",
      page.toString(),
      "&size=",
      size ? size.toString() : "",
      "&orderBy=",
      orderBy,
      "&sortBy=",
      sortBy
    );

    const r = await axiosHelper
      .getNetworkAsset()
      .get(url);

    const totalRecordsHeader = r.headers["total_records"];
    const totalRows = totalRecordsHeader ? Number(totalRecordsHeader) : 0;
    const data = r.data;

    return { rows: data, total: totalRows };
  }

  async function getGatewayStatus(
    siteId,
    page,
    size,
    orderBy,
    sortBy
  ) {
    const url = statusPathV3.concat(
      "/gateways?",
      generateParamsString(
        siteId,
        page,
        size,
        orderBy,
        sortBy,
      ),
    );
    
    const url2 = networkAssetPath.concat(
      "/gateways?",
      generateParamsString(
        siteId
      ),
    );

    const r = await axiosHelper
      .getNetworkAsset()
      .get(url);

  
    const resp = await axiosHelper
    .getNetworkAsset()
    .get(url2);  

      const totalRecordsHeader = r.headers["total_records"];
      const totalRows = totalRecordsHeader ? Number(totalRecordsHeader) : 0;
      const data = r.data.map(row => {
        const dwl_channel =  resp?.data.find(x => x.nodeAddress == row.properties.nodeAddress);
        if(dwl_channel){
          row.properties.downlink_channel = dwl_channel?.gatewayConfig?.cfg_downlink_channel;
        }
        row.properties.nameSearchField = row.properties.name? row.properties.name.toLowerCase() : '';
        row.properties.nodeSearchField = row.properties.nodeAddress? row.properties.nodeAddress.replaceAll('-', '').toLowerCase():'';
      return row;
    });

    return { rows: data, total: totalRows };
  }
  async function getCSVData(
    siteId,
    page,
    size,
    orderBy,
    sortBy,
    format,
    call
  ) {
    let basePath = (call == '/locations/unprovisioned?' || call == '/accessPoints/unprovisioned?' || call == '/status?') ? networkAssetPathV3 : statusPathV3;
    const url = basePath.concat(
      call,
      generateParamsString(
        siteId,
        page,
        size,
        orderBy,
        sortBy,
        format
      ),
    );
    const r = await axiosHelper
      .getNetworkAsset()
      .get(url);
      return r.data;
  }

  async function getAccessPointStatus(
    siteId,
    page,
    size,
    orderBy,
    sortBy
  ) {
    const url = statusPathV3.concat(
      "/accessPoints?",
      generateParamsString(
        siteId,
        page,
        size,
        orderBy,
        sortBy,
      ),
    );

    const r = await axiosHelper
      .getNetworkAsset()
      .get(url);

    const totalRecordsHeader = r.headers["total_records"];
    const totalRows = totalRecordsHeader ? Number(totalRecordsHeader) : 0;
    const data = r.data.map(row => {
      row.properties.nameSearchField = row.properties.name? row.properties.name.toLowerCase() : '';
        row.properties.nodeSearchField = row.properties.nodeAddress? row.properties.nodeAddress.replaceAll('-', '').toLowerCase():'';
      return row;
    });

    return { rows: data, total: totalRows };
  }

  async function getLocationBeaconStatus(
    siteId,
    page,
    size,
    orderBy,
    sortBy
  ) {
    const url = statusPathV3.concat(
      "/locations?",
      generateParamsString(
        siteId,
        page,
        size,
        orderBy,
        sortBy,
      ),
    );

    const r = await axiosHelper
      .getNetworkAsset()
      .get(url);

    const totalRecordsHeader = r.headers["total_records"];
    const totalRows = totalRecordsHeader ? Number(totalRecordsHeader) : 0;
    const data = r.data.map(row => {
      row.properties.nameSearchField = row.properties.name? row.properties.name.toLowerCase() : '';
      row.properties.nodeSearchField = row.properties.nodeAddress? row.properties.nodeAddress.replaceAll('-', '').toLowerCase():'';
      return row;
    });

    return { rows: data, total: totalRows };
  }

  async function getTagStatus(
    siteId,
    page,
    size,
    orderBy,
    sortBy
  ) {
    const url = statusPathV3.concat(
      "/tags?",
      generateParamsString(
        siteId,
        page,
        size,
        orderBy,
        sortBy,
      ),
    );

    const r = await axiosHelper
      .getNetworkAsset()
      .get(url);

    const totalRecordsHeader = r.headers["total_records"];
    const totalRows = totalRecordsHeader ? Number(totalRecordsHeader) : 0;
    const data = r.data.map(row => {
      row.properties.nameSearchField = row.properties.name? row.properties.name.toLowerCase() : '';
      row.properties.nodeSearchField = row.properties.nodeAddress? row.properties.nodeAddress.replaceAll('-', '').toLowerCase():'';
      return row;
    });

    return { rows: data, total: totalRows };
  }

  async function getSiteInfo(siteId) {
    const url = sitePath.concat(siteId);

    const r = await axiosHelper
      .getNetworkAsset()
      .get(url);

    return r.data;
  }

  function generateParamsString(
    siteId,
    page,
    size,
    orderBy,
    sortBy,
    format = 'json'
  ) {
    let params = 'siteId='.concat(siteId);
    if (page && format != 'csv') {
      params = params.concat("&page=", page.toString());
    }
    if (size && format != 'csv') {
      params = params.concat("&size=", size.toString());
    }
    if (orderBy) {
      params = params.concat("&orderBy=", orderBy);
    }
    if (sortBy) {
      params = params.concat("&sortBy=", sortBy);
    }
    if (format) {
      params = params.concat("&format=", format);
    }
    return params;
  }

  async function restartDevice(deviceType, nodeAddress) {
    const payload = {
      nodeAddress: nodeAddress,
      nodeType: deviceType
    }
    const response = await axiosHelper.getClientEdge().post('/v2/restartCommand',payload);
    return response;
  }

  return {
    getNetworkConnectionStatus,
    getSiteInfo,
    getDeviceStatus,
    getDevicesCount,
    restartDevice,
    getUnprovisionedLocationBeaconStatus,
    getUnprovisionedAccessPointStatus,
    getGatewayStatus,
    getCSVData,
    getAccessPointStatus,
    getLocationBeaconStatus,
    getTagStatus,
  };
})();
